import { render, staticRenderFns } from "./AddReservation2.vue?vue&type=template&id=f4a92e7a&scoped=true&"
import script from "./AddReservation2.vue?vue&type=script&lang=js&"
export * from "./AddReservation2.vue?vue&type=script&lang=js&"
import style0 from "./AddReservation2.vue?vue&type=style&index=0&id=f4a92e7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a92e7a",
  null
  
)

export default component.exports